import React, {createContext, Fragment, HTMLAttributes, useContext, useEffect} from "react";
import {useWpContext} from "./WordPressProvider.tsx";
import {useFetchDetailedUnitsQuery, useFetchListingQuery} from "../../store/api-rest.ts";
import {CtrInscriptions, CtrUnitesDetaillees} from "../../graphql/generated/graphql-main.tsx";

type ListingContextData = {
    listing: CtrInscriptions | null;
}
// default value to be passed if nothing else is provided (null by default)
const ListingContext = createContext<ListingContextData>({listing: null});

export const useSingleListing = () => useContext<ListingContextData>(ListingContext);

/**
 * Count the detailed Centris unit rows, which include every unit type for the listing.
 * No rows means the feed provides no reliable replacement for the listing's fallback value.
 */
const totalUnitsFromDetails = (detailedUnits?: CtrUnitesDetaillees[]): number | null =>
    detailedUnits != null && detailedUnits.length > 0 ? detailedUnits.length : null;

const SingleListingProvider = ({children}: HTMLAttributes<any>) => {
    const {others} = useWpContext<ZListingSingle>();

    // use RTK Query to fetch from Node REST endpoint (very fast)
    const {data, error, isLoading} = useFetchListingQuery(others.mls_id);
    const {data: detailedUnits} = useFetchDetailedUnitsQuery(others.mls_id);
    const totalUnits = totalUnitsFromDetails(detailedUnits);
    const listing = data == null || totalUnits == null
        ? data ?? null
        : {...data, NB_UNITES_TOTAL: String(totalUnits)};
    const contextValue: ListingContextData = {listing};

    // if main 'inscription' query returns empty (meaning listing is unauthorized or not found), redirect user
    useEffect(() => {
        // note: 'isLoading' check is crucial; otherwise, the page never has time to load and always redirected
        if (isLoading || data?.NO_INSCRIPTION != null) return;
        // redirect to all listings or to home page if not defined
        window.location.href = others.url_listing_all ?? window.location.origin;
    }, [data]);

    return <Fragment>
        {/*<LoadingBackdrop loading={isLoading}/>*/}

        <ListingContext.Provider value={contextValue}>
            {/* todo useless to show warning since we're redirecting to all listings anyway */}
            {/*{(!isLoading && data?.NO_INSCRIPTION == null) && <Alert severity={"warning"}>*/}
            {/*    {__("Ce listing ne semble pas exister.")}*/}
            {/*</Alert>}*/}

            {/* show children of the context provider ONLY if the API returned a valid master listing */}
            {data?.NO_INSCRIPTION != null && children}
        </ListingContext.Provider>
    </Fragment>
}
export default SingleListingProvider;
